import {ActivatedRoute, Router} from '@angular/router';
import {BDFilter, BDRadioFilter} from '@brother-apps/brother-dealerapp-shared-lib';

import {BDCPConstsService} from '../../shared/services/consts.service';
import {Injectable} from '@angular/core';
import {first} from 'rxjs/operators';
import {firstValueFrom} from 'rxjs';

@Injectable()
export class BDCPFilterService {

    public searchValue: string;
    public selectedFilters: BDFilter[];

    public constructor(
        private consts: BDCPConstsService,
        private route: ActivatedRoute,
        private router: Router
    ) {
    }

    public setFilters(filters: BDFilter[]): void {
        this.searchValue = '';
        this.selectedFilters = filters;
    }

    public canSearchBySearchValue(): boolean {
        return this.searchValue && this.searchValue.trim() !== '';
    }

    public searchBySearchValue(): void {
        if (!this.canSearchBySearchValue()) {
            return;
        }
        this.selectedFilters = [];
        this.router.navigate(['/products', 'product-finder', 'search', this.searchValue]);
    }

    public async searchByFilters(): Promise<void> {
        this.searchValue = '';
        const queryParams = this.getQueryParams();
        const currentQueryParams = await firstValueFrom(this.route.queryParams);
        queryParams['user'] = currentQueryParams['user'];
        await this.router.navigate(
            ['/products', 'product-finder', 'results'],
            {queryParams: queryParams}
        );
    }

    private getQueryParams(): { [key: string]: string | string[] } {
        const queryParams = {};
        const productCategory = this.selectedFilters[0].label;

        for (const filter of this.selectedFilters) {
            console.log(filter);
            if (queryParams[filter.internalName]) {
                if (!Array.isArray(queryParams[filter.internalName])) {
                    queryParams[filter.internalName] = [queryParams[filter.internalName], this.getFilterValue(productCategory, filter)];
                } else {
                    (<string[]>queryParams[filter.internalName]).push(this.getFilterValue(productCategory, filter));
                }
            } else {
                queryParams[filter.internalName] = this.getFilterValue(productCategory, filter);
            }
        }

        return queryParams;
    }

    private getFilterValue(productCategory: string, filter: BDFilter): string {
        console.log(productCategory, filter);
        switch (productCategory) {
            case 'Beschriftungsgeräte':
                return this.consts.possibleLabelerQueryParams[filter.internalName](filter);
            case 'Drucker':
                return this.consts.possiblePrinterQueryParams[filter.internalName](filter);
            case 'Scanner':
                return this.consts.possibleScannerQueryParams[filter.internalName](filter);
            case 'MFC/DCP':
                return this.consts.possibleMfcQueryParams[filter.internalName](filter);
            case 'Faxgeräte':
                return this.consts.possibleFaxQueryParams[filter.internalName](filter);
            default:
                return '';
        }
    }
}
